<template>
     <!---delete account modal--->
     
        <div class="modal fade" id="delete-acc-popup" tabindex="-1" aria-labelledby="exampleModalLabel"
            aria-modal="true" role="dialog">
            <div class="modal-dialog modal-dialog-centered" >
                <div class="modal-content">
                <div class="modal-header">
                    <h5>{{$t('delete','Delete')}}</h5>
                </div>
                   
                    <div class="modal-body ps-2 pe-2 pb-1">
                        <div class="flex flex-col gap-y-0 mb-0" style="max-height: 450px; overflow-y: auto;">
                            <div class="delet_acc">
                                <div class="logout_img"><img src="@/assets/images/logoutimg.svg" alt="delet"></div> 
                                    <span class="del_acc">{{$t('delete-account','Delete Account')}} ?</span>
                                   <p class="sure_text">{{$t('are-you-sure-you-want-to-delete-this-account','Are You Sure Want To, Delete This Account ?')}}</p>
                            </div>
                          <div class="footer-buttonWrap mt-2">
                            <button type="button" class="buttonWrap-btn buttonCancel" ref="closeCashoutModal" data-bs-dismiss="modal" @click="$emit('close')">{{$t('no', 'No')}}</button>
                            <button class="buttonWrap-btn buttonTheme" type="button" @click="deleteServiceCall()">{{$t('yes', 'Yes')}}</button>
                         </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>

</template>
<script>
import { removeAccount } from '../services/walletWithdraw'
export default {
    name: 'DeleteAccount',
    props: ['item'],
    emits: ['close', 'yes-click'],    
     methods:{
        async deleteServiceCall() {
              let response = await removeAccount(this.item.client_account_id)
            if(response) {
                this.$emit('yes-click');
            }
            else {
               this.$helper.closeModal('delete-acc-popup');
            }

        }
    },
};
</script>